import { typedEnv } from "@/config/typedEnv"
import { type Product } from "types"

const resolveProductDemoSku = (product: Product): string | null => {
  const skuValue = product.skus?.find((sku) => sku.sku?.trim())?.sku?.trim()
  if (skuValue) return skuValue

  const skuIdValue = product.skus?.find((sku) => sku.id?.trim())?.id?.trim()
  if (skuIdValue) return skuIdValue

  return product.sku?.trim() || null
}

export const isCanonicalPlatformMerchantId = (merchantId: string): boolean =>
  merchantId.trim().startsWith("mch_")

export const resolveProductDemoVariantId = (product: Product): string | undefined =>
  product.skus?.find((sku) => sku.id?.trim())?.id.trim() || undefined

export const isTrustedProductDemoUrl = (value: string): boolean => {
  try {
    const expected = new URL(`https://${typedEnv.VITE_TINT_WIDGET_LINK}/`)
    return new URL(value).origin === expected.origin
  } catch {
    return false
  }
}

export const buildProductDemoUrl = (merchantId: string, product: Product): string | null => {
  const normalizedMerchantId = merchantId.trim()
  const productId = product.id?.trim()
  const sku = resolveProductDemoSku(product)

  if (!normalizedMerchantId || !sku || !productId) return null

  const url = new URL(`https://${typedEnv.VITE_TINT_WIDGET_LINK}/`)
  url.searchParams.set("merchantId", normalizedMerchantId)
  url.searchParams.set("customer_product_skus", sku)
  url.searchParams.set("product_id", productId)

  return url.toString()
}

export const buildGlassesDemoUrl = buildProductDemoUrl
